export default "__VITE_ASSET__DcYrQAcq__"